var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['bottom-button', _vm.obj.absolute?'position-absolute': 'position-fixed'],style:({
    paddingBottom: _vm.obj.bottom ? _vm.obj.bottom : '30px', paddingTop:'10px',
    background: _vm.obj.background? _vm.obj.background:'transparent'
  })},_vm._l((_vm.obj.list),function(item,index){return _c('button',{key:index,class:[
      'weui-btn', 
      !item.type?'weui-btn_default':'',
      item.type=='primary'?'weui-btn_primary':'',
      item.type=='warn'?'weui-btn_warn':'',
      item.type=='disabled'?'weui-btn_disabled':'',
      item.type=='blueBt'?'blueBt':'' ],style:({height:'42px', background: item.color, width: item.width?item.width:'95%',
    }),on:{"click":function($event){return _vm.onClick(item)}}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }